import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { selectCasinoGamesOnlinePlayersLoaded, fetchOnlinePlayers, onlinePlayersSocketSuccess } from "@nxplatform/casino/casino-games-online-players.slice";
import { typedShallowEqual } from "@nxplatform/helpers/helpers";
import { WSPublicChannel } from "@service/api-client/websockets/ws-client";
import { webViewStatus } from "./query.hook.js";
import { selectPlatformSettingsCasinoPlayersOnline } from "@nxplatform/platform-settings/platform-settings.selectors";
const getParams = () => ({
  ...!webViewStatus() ? { isDesktop: 1 } : {},
  ...webViewStatus() ? { isMobileApp: 1 } : {}
});
const isFeatureEnabled = (enabledOnWeb, enabledOnMobApp) => {
  return webViewStatus() && enabledOnMobApp || !webViewStatus() && enabledOnWeb;
};
const getChannelName = () => {
  const { isDesktop, isMobileApp } = getParams();
  return [
    WSPublicChannel.casinoPlayersOnline,
    ...isDesktop ? ["desktop"] : [],
    ...isMobileApp ? ["mobile"] : []
  ].join("-");
};
const useCasinoGamesOnlinePlayers = ({
  addPublicWsChannels,
  isTextPage,
  publicWsAliveChannels,
  removePublicWsChannels
}) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const {
    playersOnlineSettings: { enabledOnWeb, enabledOnMobApp },
    onlinePlayersLoaded
  } = useSelector(
    (state) => ({
      playersOnlineSettings: selectPlatformSettingsCasinoPlayersOnline(state),
      onlinePlayersLoaded: selectCasinoGamesOnlinePlayersLoaded(state)
    }),
    typedShallowEqual
  );
  useEffect(() => {
    return () => {
      removePublicWsChannels([getChannelName()]);
    };
  }, []);
  useEffect(() => {
    if (isTextPage || onlinePlayersLoaded || !isFeatureEnabled(enabledOnWeb, enabledOnMobApp)) return;
    dispatch(fetchOnlinePlayers(getParams()));
  }, [pathname, enabledOnWeb, enabledOnMobApp, onlinePlayersLoaded]);
  useEffect(() => {
    const hasConnected = publicWsAliveChannels.includes(getChannelName());
    if (!isFeatureEnabled(enabledOnWeb, enabledOnMobApp) || isTextPage || hasConnected) return;
    addPublicWsChannels({
      channels: [getChannelName()],
      handler: (payload) => onlinePlayersSocketSuccess(payload)
    });
  }, [
    isTextPage,
    enabledOnMobApp,
    enabledOnWeb,
    JSON.stringify(publicWsAliveChannels)
  ]);
};
export {
  getChannelName,
  getParams,
  useCasinoGamesOnlinePlayers
};
